/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserUpdateFirstname } from './userUpdateFirstname';
import type { UserUpdateLastname } from './userUpdateLastname';
import type { UserUpdateEmail } from './userUpdateEmail';
import type { UserUpdateCohort } from './userUpdateCohort';
import type { UserUpdateRole } from './userUpdateRole';
import type { UserUpdateTitle } from './userUpdateTitle';
import type { UserUpdateActive } from './userUpdateActive';
import type { UserUpdateState } from './userUpdateState';
import type { UserUpdateFeatures } from './userUpdateFeatures';
import type { UserUpdateTrial } from './userUpdateTrial';
import type { UserUpdateNotificationPrefs } from './userUpdateNotificationPrefs';
import type { UserUpdateExternalStudentId } from './userUpdateExternalStudentId';

/**
 * Model to update existing users
 */
export interface UserUpdate {
  firstname?: UserUpdateFirstname;
  lastname?: UserUpdateLastname;
  email?: UserUpdateEmail;
  cohort?: UserUpdateCohort;
  role?: UserUpdateRole;
  title?: UserUpdateTitle;
  active?: UserUpdateActive;
  /** Lifecycle state for all users. Note that 'stale' and 'finished' primarily apply to students. */
  state?: UserUpdateState;
  features?: UserUpdateFeatures;
  trial?: UserUpdateTrial;
  notificationPrefs?: UserUpdateNotificationPrefs;
  externalStudentId?: UserUpdateExternalStudentId;
}
